// extracted by mini-css-extract-plugin
export var productImage = "_wx-0";